// SVG geometry copied from submitted iOS60 SocialProviderLogo; official Apple license accepted 2026-10-09.
import React from 'react';
export function SocialProviderLogo({ provider, size = 48, isDark = false }) {
  if (provider === 'apple') {
    // Official artwork has a 44 × 44 button at (6, 6) within a 56 × 56 artboard.
    // Map that button area to size; preserve its internal padding and the original logo path.
    // Only the button background is circular. Source and license: assets/apple-sign-in/README.md.
    return (
      <svg aria-hidden="true" height={size} viewBox="6 6 44 44" width={size}>
        <circle cx="28" cy="28" fill={isDark ? '#FFFFFF' : '#000000'} r="22" />
        <path
          d="M28.2226562,20.3846154 C29.0546875,20.3846154 30.0976562,19.8048315 30.71875,19.0317864 C31.28125,18.3312142 31.6914062,17.352829 31.6914062,16.3744437 C31.6914062,16.2415766 31.6796875,16.1087095 31.65625,16 C30.7304687,16.0362365 29.6171875,16.640178 28.9492187,17.4494596 C28.421875,18.06548 27.9414062,19.0317864 27.9414062,20.0222505 C27.9414062,20.1671964 27.9648438,20.3121424 27.9765625,20.3604577 C28.0351562,20.3725366 28.1289062,20.3846154 28.2226562,20.3846154 Z M25.2929688,35 C26.4296875,35 26.9335938,34.214876 28.3515625,34.214876 C29.7929688,34.214876 30.109375,34.9758423 31.375,34.9758423 C32.6171875,34.9758423 33.4492188,33.792117 34.234375,32.6325493 C35.1132812,31.3038779 35.4765625,29.9993643 35.5,29.9389701 C35.4179688,29.9148125 33.0390625,28.9122695 33.0390625,26.0979021 C33.0390625,23.6579784 34.9140625,22.5588048 35.0195312,22.474253 C33.7773438,20.6382708 31.890625,20.5899555 31.375,20.5899555 C29.9804688,20.5899555 28.84375,21.4596313 28.1289062,21.4596313 C27.3554688,21.4596313 26.3359375,20.6382708 25.1289062,20.6382708 C22.8320312,20.6382708 20.5,22.5950413 20.5,26.2911634 C20.5,28.5861411 21.3671875,31.013986 22.4335938,32.5842339 C23.3476562,33.9129053 24.1445312,35 25.2929688,35 Z"
          fill={isDark ? '#000000' : '#FFFFFF'}
          fillRule="nonzero"
        />
      </svg>
    );
  }

  if (provider === 'google') {
    return (
      <svg aria-hidden="true" height={size} viewBox="0 0 40 40" width={size}>
        <circle cx="20" cy="20" fill="#FFFFFF" r="19.5" stroke="#DEDEDE" />
        <path
          d="M29.6 20.227c0-.709-.064-1.39-.182-2.045H20v3.868h5.382c-.232 1.25-.936 2.309-1.996 3.018v2.509h3.232c1.891-1.741 2.982-4.305 2.982-7.35Z"
          fill="#4285F4"
        />
        <path
          d="M20 30c2.7 0 4.964-.896 6.618-2.423l-3.232-2.509c-.895.6-2.041.955-3.386.955-2.605 0-4.809-1.76-5.596-4.123h-3.34v2.591C12.708 27.759 16.09 30 20 30Z"
          fill="#34A853"
        />
        <path
          d="M14.405 21.9a5.89 5.89 0 0 1-.314-1.9c0-.659.114-1.3.314-1.9v-2.591h-3.341A9.96 9.96 0 0 0 10 20c0 1.614.386 3.141 1.064 4.491l3.341-2.591Z"
          fill="#FBBC04"
        />
        <path
          d="M20 13.977c1.468 0 2.786.505 3.823 1.496l2.868-2.869C24.959 10.991 22.695 10 20 10c-3.909 0-7.291 2.241-8.936 5.509l3.34 2.591c.787-2.364 2.991-4.123 5.596-4.123Z"
          fill="#E94235"
        />
      </svg>
    );
  }

  if (provider === 'naver') {
    return (
      <svg aria-hidden="true" height={size} viewBox="0 0 40 40" width={size}>
        <circle cx="20" cy="20" fill="#03C75A" r="20" />
        <path
          d="m22.599 20.51-5.412-7.748H12.7v14.476h4.7V19.49l5.413 7.748h4.486V12.762h-4.7v7.748Z"
          fill="#FFFFFF"
        />
      </svg>
    );
  }

  return (
    <svg aria-hidden="true" height={size} viewBox="0 0 48 48" width={size}>
      <circle cx="24" cy="24" fill="#FEE500" r="24" />
      <path
        d="M12 3C5.373 3 0 7.243 0 12.476c0 3.405 2.268 6.39 5.671 8.059-.25.921-.905 3.337-1.035 3.856-.162.643.236.635.497.462.204-.135 3.249-2.207 4.564-3.1.746.11 1.515.167 2.303.167 6.627 0 12-4.243 12-9.476S18.627 3 12 3Z"
        fill="#191919"
        transform="translate(12 10)"
      />
    </svg>
  );
}
